// src/components/sections/PayPalExamples.tsx
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PAYMENT_TYPES, EXAMPLE_CATEGORIES, formatCurrency } from "@/lib/constants";

const PayPalExamples = () => {
  return (
    <Card className="bg-white">
      <CardHeader>
        <CardTitle>Berechnungsbeispiele</CardTitle>
        <p className="text-gray-600">
          Hier finden Sie praktische Beispiele für verschiedene PayPal-Zahlungsarten und deren Gebühren nach den aktuellen Konditionen von Januar 2025.
        </p>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Object.entries(EXAMPLE_CATEGORIES).map(([key, category]) => (
            <Card key={key} className="bg-gray-50">
              <CardHeader className="pb-3">
                <CardTitle className="text-lg">{category.title}</CardTitle>
                <p className="text-sm text-gray-600">{category.description}</p>
              </CardHeader>
              <CardContent>
                {PAYMENT_TYPES
                  .filter((type) => {
                    if (key === 'standard') return ['goods', 'friends', 'donations'].includes(type.id);
                    if (key === 'business') return type.id.startsWith('merchant');
                    return ['micro', 'qr'].includes(type.id);
                  })
                  .map((type) => (
                    <div key={type.id} className="mb-6 last:mb-0">
                      <h4 className="font-semibold mb-2">{type.label}</h4>
                      <p className="text-sm text-gray-600 mb-3">{type.example.description}</p>
                      <div className="bg-white p-4 rounded-lg shadow-sm">
                        <div className="grid grid-cols-2 gap-2 text-sm">
                          <div>Betrag:</div>
                          <div className="text-right font-medium">
                            {formatCurrency(type.example.amount)}
                          </div>
                          <div>Gebühren:</div>
                          <div className="text-right text-red-600 font-medium">
                            {formatCurrency(type.example.fees)}
                          </div>
                          <div className="font-semibold">Gesamt:</div>
                          <div className="text-right text-green-600 font-semibold">
                            {formatCurrency(type.example.total)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </CardContent>
            </Card>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default PayPalExamples;